



















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

import SAPSailingAnalyticsAPI, { Race, Regatta } from '@/assets/scripts/sapsa-api'

@Component
export default class RaceButton extends Vue {
    private analytics!: SAPSailingAnalyticsAPI

    @Prop()
    private server?: string

    @Prop()
    private apiToken?: string

    @Prop()
    private regattaName?: string

    @Prop()
    private trackedRaceName?: string

    @Prop()
    private title?: string|false

    @Prop({ default: false })
    private noStyles?: boolean

    @Prop({ default: 'tab' })
    private linkMode?: 'tab'|'popup'

    private regatta: Regatta|null = null
    private race: Race|null = null

    private refreshInterval = 60 * 1000 // 60s

    private raceState: { running?: boolean, finished?: boolean } = { }

    private mounted () {
        this.initSapsa()
    }

    // SAP Sailing Analytics
    private async initSapsa (): Promise<void> {
        if (this.server == null || this.apiToken == null || this.regattaName == null || this.trackedRaceName == null) {
            console.warn('Please supply a server, api token, regatta and race name')
            return
        }

        this.analytics = new SAPSailingAnalyticsAPI(this.server, this.apiToken)

        // The only way to get the url for a race is to query the /leaderboardgroups/{id}
        // for which we need to query /events/{id).
        // Therefore we'l build the race url ourselves and simply check whether is the correct one.
        try {
            const regatta = await this.analytics.getRegatta(this.regattaName)
            const race = regatta.races.find((race) => race.trackedName === this.trackedRaceName)

            if (race == null) {
                console.warn(`A race with tracked name ${this.trackedRaceName} does not exist.`)
                return
            }

            const raceUrl = new URL(this.server)
            raceUrl.pathname = 'gwt/RaceBoard.html'
            raceUrl.searchParams.set('leaderboardName', this.regattaName)
            raceUrl.searchParams.set('regattaName', this.regattaName)
            raceUrl.searchParams.set('raceName', this.trackedRaceName)

            race.addRaceViewerUrl(raceUrl.toString())

            this.regatta = regatta
            this.race = race

            // Kickstart refresher for status data (times request)
            this.fetchTimes()
        } catch {
            console.warn(`A regatta with name ${this.regattaName} does not exist.`)
        }
    }

    // Refill race with status info from the times call every x seconds
    private fetchTimes (): void {
        if (this.regatta != null && this.race != null) {
            this.analytics.loadTimesForRegattaAndRace(this.regatta, this.race).catch(() => {
                console.warn('Error fetching additional race times from server')
            })
        }
        // Requery in x seconds independent of whether the previous request was successfull or not
        setTimeout(this.fetchTimes, this.refreshInterval)
    }

    @Watch('race', { immediate: true, deep: true })
    private calcDerived (): void {
        const now = new Date()
        const fiveMinutesAgo = new Date(now.setMinutes(-5))

        if (this.race != null) {
            this.raceState.running = this.race.startTime != null ? this.race.startTime < fiveMinutesAgo : false

            const end = this.race.endOfRace != null ? this.race.endOfRace : this.race.endOfTracking
            this.raceState.finished = end != null ? end < now : false

            // If the race has finished, then it is no longer running
            if (this.raceState.finished === true) {
                this.raceState.running = false
            }
        }
    }

    private openLink (event: Event): boolean {
        const element = event.target as HTMLAnchorElement
        const href = element.getAttribute('href')
        if (href != null && this.linkMode === 'popup') {
            event.preventDefault()
            window.open(href, Math.random().toString(36).substring(7), // random window ref to make sure that two windows can stay open at the same time
            'width=1280,height=720,toolbar=1,resizable=0')
            return false
        }
        return true
    }
}
